import { render } from "./TronLinkPage.vue?vue&type=template&id=4e11252e&scoped=true"
import script from "./TronLinkPage.vue?vue&type=script&lang=js"
export * from "./TronLinkPage.vue?vue&type=script&lang=js"

import "./TronLinkPage.vue?vue&type=style&index=0&id=4e11252e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e11252e"]])

export default __exports__